import { makeStyles } from "tss-react/mui"
import { MAX_EMAIL_LENGTH } from "../../../../../../constants/inputValidationDefaults"
import { Typography } from "@mui/material"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { FormikTextField } from "../../../../../../shared/components/forms/Formik"
import { EntityFormValues } from "../../supportEntitiesTypes"

const useStyles = makeStyles()(() => ({
    textField: {
        width: "50%",
    },
}))

export function ContactDetailsContent() {
    const { classes } = useStyles()

    return (
        <>
            <LocalizedStrict id="support-create-entity-contact-details-subtitle">
                <Typography mb="0.5rem" fontWeight={400}>
                    Contact details
                </Typography>
            </LocalizedStrict>
            <LocalizedStrict id="support-create-entity-contact-person-label" attrs={{ label: true }}>
                <FormikTextField<EntityFormValues> name="contactPerson" label="Contact person" fullWidth />
            </LocalizedStrict>
            <LocalizedStrict id="support-create-entity-email-label" attrs={{ label: true }}>
                <FormikTextField<EntityFormValues> name="email" label="Email" className={classes.textField} maxLength={MAX_EMAIL_LENGTH} />
            </LocalizedStrict>
            <LocalizedStrict id="support-create-entity-telephone-label" attrs={{ label: true }}>
                <FormikTextField<EntityFormValues> name="telephone" label="Telephone" className={classes.textField} />
            </LocalizedStrict>
        </>
    )
}
